export default __webpack_public_path__ + "static/media/ECP-croped.b8694288.jpg";